import React from 'react';

import Modal, { ModalBody, ModalActions } from '@strava/ui/Modal';
import Button from '@strava/ui/Button';
import createNetworkingClient from 'utils/networking-client';
import I18n from 'utils/I18n';

import { useFeedEntityContext } from '../../../state/FeedEntityContext';
import {
  DELETE_COMMENT_CANCEL,
  DELETE_COMMENT_COMPLETE
} from '../../../state/feed-entity-actions';

const prefix = 'templates.comment_delete_dialog';

const CommentDeleteAlertDialog = () => {
  const { entityState, dispatch } = useFeedEntityContext();
  const close = () => dispatch({ type: DELETE_COMMENT_CANCEL });

  const deleteComment = () => {
    const { comment, entityId } = entityState;
    const commentId = comment.comment_id;
    createNetworkingClient()
      .delete('/feed/comment', {
        data: { id: commentId }
      })
      .then(
        dispatch({
          type: DELETE_COMMENT_COMPLETE,
          payload: { entityId, commentId }
        })
      )
      .catch(() => {
        // TODO log error in monorepo
      });
  };

  return (
    <>
      <Modal
        isOpen={entityState.openCommentDeleteDialog}
        onDismiss={close}
        aria-label={I18n.t(`${prefix}.are_you_sure`)}
      >
        <ModalBody>{I18n.t(`${prefix}.are_you_sure`)}</ModalBody>
        <ModalActions>
          <Button
            onClick={close}
            data-testid="cancel-delete-comment-btn"
            type="button"
          >
            {I18n.t(`${prefix}.cancel`)}
          </Button>
          <Button
            variant="primary"
            onClick={deleteComment}
            type="button"
            data-testid="confirm-delete-comment-btn"
          >
            {I18n.t(`${prefix}.ok`)}
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export default CommentDeleteAlertDialog;
